import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/users/users.service';

@Component({
	selector: 'app-edit-devices-owners',
	templateUrl: './edit-devices-owners.component.html'
})
export class EditDevicesOwnersComponent implements OnInit {
	hasAccess = false;

	constructor(
		private usersService: UsersService,
		private router: Router,
	) {}

	ngOnInit() {
		// bulk device owners editing is an SCT only page
		this.hasAccess = !!this.usersService.getCurrentUser()?.isSCT && this.usersService.hasAccessFunction('manage_device');
		if (!this.hasAccess)
			this.router.navigate(['/unauthorized']);
	}
}
